export default "__VITE_ASSET__D7FmpWKK__"